// extracted by mini-css-extract-plugin
export var button = "_ma-2";
export var card = "_ma-0";
export var closeButtonContainer = "_ma-3";
export var iconContainer = "_ma-1";